export const navbarProductsIsOpen = (isOpen) => ({
  type: "NAVBAR_PRODUCTS_IS_OPEN",
  isOpen
});